import { FORM_VALIDATIONS } from '@riseart/form';
import { subscribeFragment } from 'shared_models/forms/fragments/subscribe';
import { dialingCodes as DIALING_CODES } from 'Countries';

export const EnquireArtistCommissionFormModel = {
  settings: {
    hideRequiredMark: true,
    layout: 'horizontal',
  },
  fields: [
    {
      tag: 'input',
      type: 'email',
      name: 'email',
      validateTrigger: 'onBlur',
      rules: [
        {
          type: 'email',
          message: 'forms.common.validation_messages.not_valid_email',
        },
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_email',
        },
      ],
      label: 'forms.emailEnquire.placeholder.email',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'firstName',
      validateTrigger: 'onBlur',
      rules: [
        {
          pattern: "^[a-zA-ZÀÁÂÄÇÈÉÊÌÍÒÓÖÔÜàáäâçèéêìíòóöôüß'-\\s]*$",
          message: 'forms.common.validation_messages.not_valid_first_name',
        },
      ],
      label: 'forms.emailEnquire.placeholder.firstName',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'lastName',
      validateTrigger: 'onBlur',
      rules: [
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_last_name',
        },
        {
          pattern: "^[a-zA-ZÀÁÂÄÇÈÉÊÌÍÒÓÖÔÜàáäâçèéêìíòóöôüß'-\\s]*$",
          message: 'forms.common.validation_messages.not_valid_last_name',
        },
      ],
      label: 'forms.emailEnquire.placeholder.lastName',
    },
    {
      tag: 'phone',
      type: 'phone',
      name: 'phone',
      validateTrigger: 'onBlur',
      rules: FORM_VALIDATIONS.PHONE,
      label: 'forms.emailEnquire.placeholder.phone',
      dialingCodes: DIALING_CODES,
      initialCountryCode: 'gb',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'budget',
      validateTrigger: 'onBlur',
      rules: [
        {
          pattern: '^[0-9]*$',
          message: 'forms.common.validation_messages.notValidBudget',
        },
      ],
      label: 'forms.emailEnquire.placeholder.budget',
      prefix: (props) =>
        props && props.customData && props.customData.currencySign
          ? props.customData.currencySign
          : null,
    },
    {
      tag: 'textarea',
      name: 'message',
      label: 'forms.emailEnquire.placeholder.moreDetails',
      extra: 'forms.enquireArtistCommission.extra.moreDetails',
      maxLength: 500,
    },
    ...subscribeFragment,
  ],
};
